<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col xl="4" lg="5" md="6" cols="12" class="px-10">
                    <h1 class="mb-5">From Compliance to Connection</h1>
                    Government agencies face unique communication challenges — regulatory requirements, high service expectations, and the need to reach millions with clarity. 
                    <br><br>
                    Yabbr helps transform compliance-driven contact into meaningful engagement.
                    <div>
                        <v-list class="features grey-card">
                            <v-list-item v-for="item in items" :key="item">
                                <v-list-item-icon>
                                    <v-icon color="green">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-text>{{ item }}</v-list-item-text>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                    <v-btn
                    class="btn-primary--outline rounded-pill mt-8"
                    outlined
                    large
                    :ripple="false"
                    href="/chat"
                    >
                    Yabbr Chat
                    <v-icon>mdi-arrow-right-thin</v-icon>
                </v-btn>
                </v-col>
                <v-col xl="4" lg="4" md="6" col="12" class="d-flex align-center justify-center px-10">
                    <v-img
                    src="../assets/img/gov.jpg"
                    contain
                    max-width="350px"
                    alt="sitemap"
                    class="rounded-xl"
                    
                     /> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'WorkflowsFeatures',
    data: () => ({
        items: [
            'Send urgent alerts to communities with confidence (SMS, MMS, Email, Voice).',
            'Automate workflows to manage reminders, renewals, or notifications at scale.',
            'Capture insights through surveys that adapt to citizen responses.',
            'Provide secure, accessible two-way channels for feedback and support.',
        ]
    })
}
</script>




<style lang="scss">

</style>